// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1iLTB","spin":"Spinner_spin__3aap1"};